module.exports = __webpack_public_path__ + "img/sun-collection-white.72d6e431.svg";